import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    initialLoading: true,
    loading: false,
    hotelLanguages: {},
    preferredLanguageCode: "",
    error: false,
    errorMessage: ''
};

const hotelLangSlice = createSlice({
    name: 'hotelLang',
    initialState,
    reducers: {
        resetHotelLang: () => initialState,
        initHotelLangRequest: state => {
            state.loading = true;
            state.error = false;
            state.errorMessage = '';
        },
        getHotelLangSuccess: (state, action) => {
            state.initialLoading = false;
            state.loading = false;

            state.hotelLanguages = action.payload
            state.preferredLanguageCode = action.payload.preferredLanguageCode
        },
        getHotelLangFailure: (state, action) => {
            state.initialLoading = false;
            state.loading = false;
            state.error = action.payload.isError;
            state.errorMessage = action.payload.errorMessage;
        },
    },
});

export const {
    resetHotelLang,
    initHotelLangRequest,
    getHotelLangSuccess,
    getHotelLangFailure,
} = hotelLangSlice.actions;

export default hotelLangSlice.reducer;
